var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "clearfix subtable-font-style pagination-comp" },
    [
      _vm.nTotalRowCount > 0
        ? _c(
            "div",
            { staticClass: "row pagination-wrapper justify-content-between" },
            [
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "currentPage" }, [
                  _c("div", { staticClass: "currentPageContent" }, [
                    _vm.nItemsPerPage > _vm.nTotalRowCount ||
                    (_vm.nCurrentPage - 1) * _vm.nItemsPerPage +
                      _vm.nItemsPerPage >
                      _vm.nTotalRowCount
                      ? _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$n(
                                  (_vm.nCurrentPage - 1) * _vm.nItemsPerPage + 1
                                )
                              ) +
                              "-" +
                              _vm._s(_vm.$n(_vm.nTotalRowCount)) +
                              " " +
                              _vm._s(_vm.$t("components.pagination.of")) +
                              " " +
                              _vm._s(_vm.$n(_vm.nTotalRowCount)) +
                              "\n                    "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$n(
                                  (_vm.nCurrentPage - 1) * _vm.nItemsPerPage + 1
                                )
                              ) +
                              "-" +
                              _vm._s(
                                _vm.$n(
                                  (_vm.nCurrentPage - 1) * _vm.nItemsPerPage +
                                    _vm.nItemsPerPage
                                )
                              ) +
                              " " +
                              _vm._s(_vm.$t("components.pagination.of")) +
                              " " +
                              _vm._s(_vm.$n(_vm.nTotalRowCount)) +
                              "\n                    "
                          ),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "perPage" }, [
                  _c("form", { staticClass: "perPageContent" }, [
                    _c("span", { staticClass: "perPageContent__text" }, [
                      _vm._v(_vm._s(_vm.$t("components.pagination.rows"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nItemsPerPage,
                            expression: "nItemsPerPage",
                          },
                        ],
                        staticClass:
                          "form-control form-control-sm subtable-font-style perPageContent__input",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.nItemsPerPage = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.fnPageSizeChange($event)
                            },
                          ],
                        },
                      },
                      _vm._l(_vm.arrItemsPerPageOptions, function (option) {
                        return _c("option", { domProps: { value: option } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option) +
                              "\n                        "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-0" }, [
                _c("nav", [
                  _c(
                    "ul",
                    { staticClass: "pagination mb-0" },
                    [
                      _vm.showFirstLastBtns
                        ? _c(
                            "li",
                            {
                              class: [
                                { disabled: _vm.prevPageDisabled },
                                "page-item",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.startPage()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "mdi mdi-arrow-collapse-left",
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: [
                            { disabled: _vm.prevPageDisabled },
                            "page-item",
                          ],
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "page-link",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.prevPage()
                                },
                              },
                            },
                            [_c("span", { staticClass: "mdi mdi-arrow-left" })]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.range, function (n) {
                        return _c("li", { staticClass: "page-item" }, [
                          _c(
                            "a",
                            {
                              class: [
                                { selectedPage: n === _vm.nCurrentPage },
                                "page-link",
                              ],
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.setPage(n)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$n(n)))]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: [
                            { disabled: _vm.nextPageDisabled },
                            "page-item",
                          ],
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "page-link",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.nextPage()
                                },
                              },
                            },
                            [_c("span", { staticClass: "mdi mdi-arrow-right" })]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showFirstLastBtns
                        ? _c(
                            "li",
                            {
                              class: [
                                { disabled: _vm.nextPageDisabled },
                                "page-item",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.lastPage()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "mdi mdi-arrow-collapse-right",
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }